// import { AlignJustifyIcon, ChevronLeft } from 'lucide-react';
import { Button } from '@/components/common/Button';
import { observer } from 'mobx-react-lite';
import { useStore } from '@/hooks/useStore';
import ToggleBarMenuIcon from '@/assets/icons/ToggleBarMenuIcon';
// import { cn } from '@/utils/utils';

export default observer(function SidebarToggle() {
    // store
    const {
        uiStore: {
            // isOpenSidebar,
            setOpenSidebar
        }
    } = useStore();

    return (
        <div className='invisible lg:visible'>
            <Button
                variant='ghost'
                size='icon'
                className='rounded-md hover:bg-transparent transition-none w-fit'
                onClick={() => setOpenSidebar()}
            >
                <ToggleBarMenuIcon />
                {/* <AlignJustifyIcon
                    className={cn(
                        'h-4 w-4 transition-transform ease-in-out duration-700',
                        isOpenSidebar === false ? 'rotate-0' : 'rotate-0'
                    )}
                /> */}
            </Button>
        </div>
    );
});
